import { Navigate, Route, Routes } from "react-router-dom"
import { ExamMaterial } from "../containers/Exam/ExamMaterial"
import { ExamQuestionary } from "../containers/Exam/ExamQuestionary"
import { ExamResult } from "../components/Exam/ExamResult"
import { RedirectToMaterial } from "../components/Exam/RedirectToMaterial"
import { PublicRoute } from "./PublicRoute"

export const ExamRoutes = () => {
    return (
        <Routes>

            {/* Rutas de material */}
            <Route
                path="material/:id/employee/:employeeId"
                element={<ExamMaterial />}
            />

            <Route
                path="material/:id/visit/:visitId"
                element={<ExamMaterial />}
            />

            {/* Rutas de cuestionario */}
            <Route
                path="questionary/:id/employee/:employeeId"
                element={<ExamQuestionary />}
            />

            <Route
                path="questionary/:id/visit/:visitId"
                element={<ExamQuestionary />}
            />

            {/* Rutas de resultado */}
            <Route
                path="result/:id/visit/:visitId"
                element={<ExamResult />}
            />

            <Route
                path="result/:id/employee/:employeeId"
                element={<ExamResult />}
            />

            {/* Redirección por defecto: si viene sin /material o /questionary, redirigir a material */}
            <Route
                path=":id/employee/:employeeId"
                element={<RedirectToMaterial />}
            />

            <Route
                path=":id/visit/:visitId"
                element={<RedirectToMaterial />}
            />

            <Route
                path="*"
                element={<Navigate to={'/login'} replace />}
            />

        </Routes>
    )
}
